import { animate, stagger } from "motion";
//import { gsap } from "gsap";
/*
gsap.to("h1", {
  x: 200,
});*/

animate(
  "h1 span",
  { y: [100, 0], opacity: 1 },
  {
    delay: stagger(0.1),
    duration: 0.5,
    easing: [0.22, 0.03, 0.26, 1],
  }
);

animate(
  ".scroll",
  { bottom: ["-200px", "2rem"], opacity: [0, 1] },
  { duration: 0.4, delay: 1 }
);
